
    const original = "<svg width=\"310\" height=\"310\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xml:space=\"preserve\" overflow=\"hidden\"><g transform=\"translate(-1775 -1726)\"><path d=\"M1810 1849C1810 1799.29 1850.29 1759 1900 1759 1949.71 1759 1990 1799.29 1990 1849 1990 1898.71 1949.71 1939 1900 1939 1850.29 1939 1810 1898.71 1810 1849Z\" fill=\"#855CD6\" fill-rule=\"evenodd\"/><rect x=\"1884\" y=\"1851\" width=\"145\" height=\"145\" fill=\"#855CD6\"/></g></svg>";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original
                .replace(/#855cd6/gi, Recolor.primary)
                .replace(/#A384E0/gi, Recolor.primaryLight || Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
